import NbioApi from "../api/NbioApi";

const axios = require('axios');
const followGoogleMapsLink = async (link) =>{
    const res = await axios.get(link);
}
const googleMapsParser = async (text) =>{
    // Try to parse it as URL
    try{
        const url = new URL(text);
        const q = url.searchParams.get('q');
        if(q){
            let [lat,lon] = q?.split(',');
            lat = +lat;
            lon = +lon;
            // Max / Mins
            // lat 90.0 - -90.0
            // lon 180.0 - -180.0
            if(lat <= 90.0 && lat >= -90.0 && lon <=180.0 && lon >= -180.0){
                return Promise.resolve({
                    lat,lon
                });
            }
        }
        if(url.pathname.startsWith('/maps/place')){
            const pathnameParts = url.pathname.split('!');
            // const part = pathnameParts.find((p) => p.startsWith('@'));
            // const split = part.split('!');
            let lat = pathnameParts.find((s) => s.startsWith('3d')).replace("3d","");
            let lon = pathnameParts.find((s) => s.startsWith('4d')).replace("4d","");

            lat = +lat;
            lon = +lon;
            // Max / Mins
            // lat 90.0 - -90.0
            // lon 180.0 - -180.0
            if(lat <= 90.0 && lat >= -90.0 && lon <=180.0 && lon >= -180.0){
                return Promise.resolve({
                    lat,lon
                });
            }
        }
        if(url.host === 'maps.app.goo.gl'){
            // Follow link
            // const res = await followGoogleMapsLink(text);
            // console.log(res.data.responseUrl);
            const res = await NbioApi.utils.googleMapsLinkFollower(text);
            if(res.data?.url){
                // Return the parsed url
                return googleMapsParser(res.data.url);
            }
        }


    }catch (e) {
        console.log(e);
        
    }
    // Try to parse it as address
    return {
        lat: null,
        lon: null
    }
}
const GoogleMapsParser = {
    parse: googleMapsParser
}
export default GoogleMapsParser;